const initialDificultadData = {
	descripcion:'',
	icono:'',
	color:'',
	anulado:'',
	anuladoFec:'',
	codUsuAnula:''
};

const initialArrayDificultadData = [];

export { initialDificultadData, initialArrayDificultadData };
